import React from 'react';
import graph from '../graph';
import Update from '../Update';
import Create from '../Create';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

import { Fade, Card, Stack, Divider, Checkbox, IconButton, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { hasRequiredRole } from 'helpers';
import { FormattedMessage } from 'react-intl';
import { AvatarPopover, NewMediaPopup } from 'components';

export default function Model({ model, delay, refetch, selection, acception, handleSelectAllClick, isAssign }) {
  const { id, title, media, children } = model;

  const roles = ['superadmin', 'operator'];
  const { userInfo } = useSelector((state) => state.auth);
  const hasRole = hasRequiredRole(roles, userInfo?.roles);

  return (
    <>
      <Fade in unmountOnExit timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}>
        <Card
          sx={{
            position: 'relative',
            minHeight: { xs: 96, sm: 96, md: 96 },
            bgcolor: acception > 0 && selection === acception ? 'action.selected' : 'action.hover',
          }}
        >
          <Stack p={1} height="100%" columnGap={1} direction="row" alignItems="center">
            <Checkbox
              size="small"
              onChange={handleSelectAllClick}
              checked={acception > 0 && selection === acception}
              indeterminate={selection > 0 && selection < acception}
            />

            <NewMediaPopup id={id} model="ProductCategory" collection="avatar" title={title} graph={graph}>
              <AvatarPopover isAssign={isAssign} sx={{ width: 48, height: 48 }} media={media[0]?.full_url} />
            </NewMediaPopup>

            <Stack px={1} flexGrow={1}>
              <Typography variant="subtitle1" color="text.secondary">
                {title}
              </Typography>
            </Stack>
            {!hasRole && (
              <>
                <Update ids={id} refetch={refetch} title={<FormattedMessage id="update" />} />
                <Create ids={id} refetch={refetch} title={<FormattedMessage id="create" />} />
              </>
            )}
            <IconButton
              disabled
              size="small"
              sx={{ bgcolor: 'action.hover' }}
              // onClick={() => showChildren(id)}
            >
              <KeyboardArrowDownRoundedIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Card>
      </Fade>
      <Divider variant="middle" />
    </>
  );
}
